// src/components/CustomSelectLang.tsx
import {Dropdown , Space} from 'antd';
import {GlobalOutlined} from '@ant-design/icons';
import React ,{useState,useEffect}from 'react';
import {lang} from '@/utils/request.js'
const CustomSelectLang = () => {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([localStorage.getItem('umi_locale') || lang]); // 默认选中 key="2"
    const items = [
        {key: 'zh-CN' , label: ' 简体中文 ' , icon: 'CN' } ,
        {key: 'zh-TW' , label: ' 繁体中文 ' , icon: 'TW' } ,
        {key: 'en-US' , label: ' English ',icon:'EN' },
        {key: 'pt-BR' , label: ' Português ',icon:'PT' },
        {key: 'ar-EG' , label: ' العربية ',icon:'AR' }
    ]
    // const list = countries.map(item=>({key:item.code,label:}))
    const menuProps = {
        items,
        selectedKeys,
        onClick: ({ key }) => {
            setSelectedKeys(key)
            localStorage.setItem('umi_locale', key);
            window.location.reload();
        }, // 更新选中状态
    };
    useEffect(() => {
        if(!localStorage.getItem('umi_locale')){
            localStorage.setItem('umi_locale',lang)
        }
        document.documentElement.lang = localStorage.getItem('umi_locale') || 'en-US';

    } , []);
    const currentLocal = items.find(item=>item.key === selectedKeys[0])
    return (
        <Dropdown
            menu={menuProps}
            placement="bottomRight"
            // destroyPopupOnHide
        >
      <span style={{cursor: 'pointer' , padding: '0 12px'}}>
        {/*<GlobalOutlined/>*/}
        <Space> {currentLocal?.icon}{currentLocal?.label}</Space>
      </span>
        </Dropdown>
    );
};

export default CustomSelectLang;